import {$, $$, hide} from "../../core/js/Dom.ts";
import {fadeIn, fadeOut} from "../../core/js/Animate.ts";
import {ajouterLiensPageAide} from "./FormUtils.ts";
import {GeographieForm} from "../../core/js/DossierGeographie.ts";

let quatre_option = false;
document.addEventListener('DOMContentLoaded', () => {
    const typeDeFormulaire = ['avtm', 'dcnm', 'dcnmc', 'dnm', 'dnmc', 'dvtm', 'dvtmcir']
    if (typeDeFormulaire.map(type => `${type}_update`).includes(document?.body?.dataset?.url || '') || typeDeFormulaire.map(type => `${type}_add`).includes(document?.body?.dataset?.url || '')) {
        const geoForm = new GeographieForm()
        geoForm.init({
            instruction: window.Openscop.edition_is_instruction,
            interdep: window.Openscop.edition_is_interdep,
        }).catch()
        geoForm.addEventListener('geo:loading', (event) => {
            const saveBtn = $<HTMLButtonElement>('#submit-id-save')!
            saveBtn.disabled = !!(event as CustomEvent).detail;
        })
        initState()
        initListeners()
    }
})

function initState() {
    const activite = $<HTMLSelectElement>('#id_activite')?.value
    if (activite) ajouterLiensPageAide(window.Openscop.url_aide_by_activite_id, activite, $('#div_id_activite'))
    if (window.Openscop.type === "dcnmc" && activite !== "123") {
        hide($<HTMLElement>('#div_id_priorite_passage'))
        hide($<HTMLElement>('#div_id_respect_code_route'))
    } else {
        quatre_option = true
    }

    toggleSwitchDetail($<HTMLInputElement>('#id_police_municipale'))
    toggleSwitchDetail($<HTMLInputElement>('#id_police_nationale'))

    const dansCalendrier = $<HTMLInputElement>('#id_dans_calendrier')
    if (dansCalendrier) {
        if (dansCalendrier.checked) {
            toggleAffiliationElement(dansCalendrier)
        } else {
            toggleAffiliationElement($<HTMLInputElement>('#id_avec_convention_fede')!)
        }
    }

    const signaleurs = $<HTMLInputElement>('[name="nb_signaleurs"]')
    if (signaleurs) handleSignaleurState(signaleurs)

    // vérifié si vraiment nécéssaire puisque les form sont different normalement la date de fin est disabled dans le form homologation?
    const pageHeader = $<HTMLElement>('#page-header')
    if (pageHeader && pageHeader.innerText.includes('Homologation')) {
        const dateDebut = $<HTMLInputElement>('#id_date_debut')
        if (dateDebut && dateDebut.value !== "") {
            const dateFin = $<HTMLInputElement>('#id_date_fin')
            if (dateFin) {
                dateFin.disabled = true
            }
        }
    }
    initUserOrganisation()
}

function initListeners() {
    $('#id_dans_calendrier')?.addEventListener('change', (event: DOMEvent<HTMLInputElement>) => {
        toggleAffiliationElement(event.target)
    })
    $('#id_avec_convention_fede')?.addEventListener('change', (event: DOMEvent<HTMLInputElement>) => {
        toggleAffiliationElement(event.target)
    })

    $('#id_police_municipale')?.addEventListener('change', (event: DOMEvent<HTMLInputElement>) => toggleSwitchDetail(event.target))
    $('#id_police_nationale')?.addEventListener('change', (event: DOMEvent<HTMLInputElement>) => toggleSwitchDetail(event.target))

    $$('.traffic').forEach(element => element.addEventListener('change', handleTrafficOptions))

    $('[name="nb_signaleurs"]')?.addEventListener('change', (event: DOMEvent<HTMLInputElement>) => handleSignaleurState(event.target))
}

function toggleSwitchDetail(element: HTMLInputElement | null) {
    if (element) {
        const name = element.name
        const checked = element.checked
        let toggle = `div_id_detail_${name}`
        let animation = fadeOut
        if (checked) {
            animation = fadeIn
        }
        animation($<HTMLElement>(`#${toggle}`)).catch()
    }
}

function toggleAffiliationElement(element: HTMLInputElement | null) {
    if (element) {
        const id = element.id
        const checked = element.checked
        let toggle = `div_id_dans_calendrier`
        if (id === 'id_dans_calendrier') {
            toggle = 'div_id_avec_convention_fede'
        }
        let animation = fadeIn
        if (checked) {
            animation = fadeOut
        }
        animation($<HTMLElement>(`#${toggle}`)).catch()
    }
}

// BOF Régime de circulation
function check_traffic() {
    // Renvoie la liste des switches commutés
    const list = [false, false, false, false];
    if ($<HTMLInputElement>('[name="respect_code_route"]')?.checked) {
        list[0] = true;
    }
    if ($<HTMLInputElement>('[name="priorite_passage"]')?.checked) {
        list[1] = true;
    }
    if ($<HTMLInputElement>('[name="usage_temporaire"]')?.checked) {
        list[2] = true;
    }
    if ($<HTMLInputElement>('[name="usage_privatif"]')?.checked) {
        list[3] = true;
    }
    return list;
}

function which_traffic(id: string) {
    // Renvoie le switch qui a communté parmi les quatre
    const list = [false, false, false, false];
    if (id === 'id_respect_code_route') {
        list[0] = true;
    }
    if (id === 'id_priorite_passage') {
        list[1] = true;
    }
    if (id === 'id_usage_temporaire') {
        list[2] = true;
    }
    if (id === 'id_usage_privatif') {
        list[3] = true;
    }
    return list
}

function set_traffic(list: boolean[]) {
    // Communte les switches
    const respectCode = $<HTMLInputElement>('#id_respect_code_route')
    const prioritePassage = $<HTMLInputElement>('#id_priorite_passage')
    const temporaire = $<HTMLInputElement>('#id_usage_temporaire')
    const privatif = $<HTMLInputElement>('#id_usage_privatif')
    if (respectCode) respectCode.checked = list[0];
    if (prioritePassage) prioritePassage.checked = list[1];
    if (temporaire) temporaire.checked = list[2];
    if (privatif) privatif.checked = list[3];
}

// Gérer l'affichage quand les switches sont commutés
function handleTrafficOptions(event: DOMEvent<HTMLInputElement>) {
    const target = event.target
    const previous = which_traffic(target.id);
    const etat = check_traffic();
    if (!quatre_option) {
        etat[0] = false
        etat[1] = false
    }
    if (!(etat[0] || etat[1] || etat[2] || etat[3])) {
        if (quatre_option) {
            // pas de switch, on communte le suivant
            set_traffic([previous[3], previous[0], previous[1], previous[2]]);
        } else {
            // on active l'autre dans le car des sans masse
            if (target.id === "id_usage_privatif") {
                set_traffic([false, false, true, false])
            } else {
                set_traffic([false, false, false, true])
            }
        }
    } else {
        if (!quatre_option) {
            if (etat[2] && etat[3]) {
                if (target.id === "id_usage_privatif") {
                    etat[2] = false
                } else {
                    etat[3] = false
                }
                set_traffic(etat)
            }
        }

        let prev = etat[0];
        let xor = true;
        for (let i = 1; i < etat.length; i++) {
            if (prev && etat[i]) {
                // plus de un switch, on affiche le détail pour chaque
                xor = false;
                set_detail(etat);
                break;
            }
            prev = prev || etat[i];
        }
        // un seul switch, pas de détails
        if (xor) {
            set_detail([false, false, false, false]);
        }
    }
}

function handleSignaleurState(signaleurs: HTMLInputElement) {
    if (signaleurs && (signaleurs.value !== "" && signaleurs.value !== "0")) {
        fadeIn($<HTMLElement>('#div_id_nb_signaleurs_fixes')).catch()
        fadeIn($<HTMLElement>('#div_id_nb_signaleurs_autos')).catch()
        fadeIn($<HTMLElement>('#div_id_nb_signaleurs_motos')).catch()
    } else {
        fadeOut($<HTMLElement>('#div_id_nb_signaleurs_fixes')).catch()
        fadeOut($<HTMLElement>('#div_id_nb_signaleurs_autos')).catch()
        fadeOut($<HTMLElement>('#div_id_nb_signaleurs_motos')).catch()
    }
}

function initUserOrganisation() {
    $<HTMLInputElement>('#id_securite_user')?.addEventListener('change', (event: DOMEvent<HTMLSelectElement>) => choiceUserOrganisation(event.target))
    $<HTMLInputElement>('#id_user_contact')?.addEventListener('change', (event: DOMEvent<HTMLSelectElement>) => choiceUserOrganisation(event.target))
    $<HTMLInputElement>('#id_technique_user')?.addEventListener('change', (event: DOMEvent<HTMLSelectElement>) => choiceUserOrganisation(event.target))
}

function choiceUserOrganisation(select: HTMLSelectElement) {
    // Fonction qui permet de remplir les champs nom, prenom, email et tel en fonction de l'utilisateur choisi
    const value = select.value
    if (value === '0') {
        return
    }
    const utilisateur = window.Openscop.utilisateurs.find((user: any) => user.id == value)
    if (utilisateur) {
        if (select.id === 'id_securite_user') {
            $<HTMLInputElement>('#id_securite_nom')!.value = utilisateur.last_name
            $<HTMLInputElement>('#id_securite_prenom')!.value = utilisateur.first_name
            $<HTMLInputElement>('#id_securite_email')!.value = utilisateur.email
            $<HTMLInputElement>('#id_securite_tel')!.value = ""
        }
        else if (select.id === 'id_user_contact') {
            $<HTMLInputElement>('#id_nom_contact')!.value = utilisateur.last_name
            $<HTMLInputElement>('#id_prenom_contact')!.value = utilisateur.first_name
            $<HTMLInputElement>('#id_tel_contact')!.value = ""
        }
        else if (select.id === 'id_technique_user') {
            $<HTMLInputElement>('#id_technique_nom')!.value = utilisateur.last_name
            $<HTMLInputElement>('#id_technique_prenom')!.value = utilisateur.first_name
            $<HTMLInputElement>('#id_technique_email')!.value = utilisateur.email
            $<HTMLInputElement>('#id_technique_tel')!.value = ""
        }
    }
}